export default function formatNumber(number) {
    // Преобразуем число в строку и удаляем все пробелы (если они есть)
    let formattedNumber = number.toString().replace(/\s+/g, '');

    // Используем метод регулярных выражений для добавления пробелов после каждых трех цифр
    formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return formattedNumber;
}
